import style from "./style.module.css";

interface Props {
  /** Each row is [param name, value from the URL, fallback used when omitted]. */
  rows: Array<[string, string | undefined, string?]>;
}

/** Shows a list of URL parameters and their current (or default) value. */
export function StateInfoList({ rows }: Props): JSX.Element {
  return (
    <dl className={style.stateInfo}>
      {rows.map(([key, value, fallback]) => (
        <div key={key}>
          <dt>{key}</dt>
          <dd>{value ?? (fallback === undefined ? "—" : `${fallback} (standaard)`)}</dd>
        </div>
      ))}
    </dl>
  );
}
